<template>
  <div>
    <common-list
      ref="list"
      url="AccountRule/GetList"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <el-form-item label="规则名称" prop="AccountRuleTitle">
          <el-input
            v-model.trim="filter.AccountRuleTitle"
            placeholder="规则名称"
            clearable
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('AccountRuleAdd')"
          >添加</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('AccountRuleEdit')"
          >编辑</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteItem"
          v-if="
            auth('AccountRuleDelete') &&
            currentrow &&
            currentrow.IsDefault != '1'
          "
          >删除</el-button
        >
        <el-button
          type="success"
          @click="setDef"
          v-if="
            auth('SetAccountRuleDef') &&
            currentrow &&
            currentrow.IsDefault != '1'
          "
          >设为默认</el-button
        >
      </template>
      <template v-slot:body>
        <el-table-column
          label="规则名称"
          prop="AccountRuleTitle"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否单点登录" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ row.IsSso == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="最大连续失败次数"
          prop="MaxFailureCount"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="失败结果"
          prop="MaxFailureResultName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="冻结小时数" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{
              row.MaxFailureResult == "2" ? row.FreezeHours : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否默认">
          <template v-slot="{ row }">
            <span>{{ row.IsDefault == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="描述"
          prop="Remark"
          show-overflow-tooltip
        ></el-table-column>
      </template>
    </common-list>
    <add-edit
      ref="addedit"
      @success="getData"
      :item="aeitem"
      title="账户规则"
      getUrl="AccountRule/GetAccountRuleByID"
      addUrl="AccountRule/Add"
      editUrl="AccountRule/Edit"
      width="500px"
      labelWidth="150px"
    >
      <template v-slot="{ form }">
        <el-form-item
          label="规则名称"
          prop="AccountRuleTitle"
          :rules="[$g.validRequired, $g.validLen(32)]"
        >
          <el-input
            v-model.trim="form.AccountRuleTitle"
            placeholder="规则名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="单点登录" prop="IsSso" :rules="$g.validRequired">
          <DataDic v-model="form.IsSso" type="YesOrNo"></DataDic>
        </el-form-item>
        <el-form-item
          label="最大连续失败次数"
          prop="MaxFailureCount"
          :rules="[$g.validRequired, $g.validNumberAndZero]"
        >
          <el-input
            v-model.number="form.MaxFailureCount"
            placeholder="最大连续失败次数"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="失败结果"
          prop="MaxFailureResult"
          :rules="$g.validRequired"
        >
          <DataDic v-model="form.MaxFailureResult" type="UserStatus"></DataDic>
        </el-form-item>
        <el-form-item
          v-if="form.MaxFailureResult == '2'"
          label="冻结小时数"
          prop="FreezeHours"
          :rules="[$g.validRequired, $g.validNumber]"
        >
          <el-input
            v-model.number="form.FreezeHours"
            placeholder="冻结小时数"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="Remark" :rules="$g.validLen(127)">
          <el-input
            v-model.trim="form.Remark"
            placeholder="描述"
            clearable
          ></el-input>
        </el-form-item>
      </template>
    </add-edit>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aeitem: {},
    };
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.$refs.addedit.type = "add";
      this.aeitem = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$refs.addedit.type = "edit";
      this.aeitem = { AccountruleId: this.currentrow.AccountruleId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除规则名称为【${this.currentrow.AccountRuleTitle}】的规则, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("AccountRule/Delete", {
            AccountruleId: this.currentrow.AccountruleId,
          }).then(() => {
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    setDef() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$put("AccountRule/SetIsDefault", {
        AccountruleId: this.currentrow.AccountruleId,
      }).then((r) => {
        this.$message.success("设置成功");
        this.$refs.list.getTableData();
      });
    },
  },
};
</script>

<style>
</style>